<template lang="html">
  <b-container class="orders-page">
    <div>
      <div class="table table-hover table-responsive">
        <table class="order-table table-striped w-100">
          <thead>
            <tr>
              <th>ID</th>
              <th v-if="$store.user.type == 'admin'">Richiedente</th>
              <th>Stato richiesta</th>
              <th>Pallet</th>
              <th v-if="$store.user.type == 'admin'">Partner</th>
              <th>Quantità</th>
              <th>Data di inserimento</th>

              <th class="text-right w-0"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!orders">
              <td colspan="100%">
                Caricamento...
              </td>
            </tr>
            <tr v-else-if="!orders.total">
              <td colspan="100%">
                Nessun ordine
              </td>
            </tr>
            <tr v-for="order in (orders || {}).data" :key="order.id" class="pointer" @click="form = _.cloneDeep(order)">
              <td>
                #{{ order.proto }}
              </td>
              <td v-if="$store.user.type == 'admin'">
                <!-- {{ order.user.full_name }} -->
                {{ order.user.company }} ({{ order.user.name }} {{order.user.surname}})
              </td>
              <td>
                {{ $t('order_status.'+order.status) }}
              </td>
              <td v-if="!order.product.is_varie">
                {{ order.product.product_type.code }} / {{ order.product.name }}
              </td>
              <td v-else>
                Varie / {{ order.product.name }}
              </td>
              <td v-if="$store.user.type == 'admin'">
                <!-- {{ order.product.user.full_name }} -->
                {{ order.product.user.company }} ({{ order.product.user.name }} {{order.product.user.surname}})
              </td>
              <td>
                {{ order.quantity }}
              </td>
              <td>
                {{ order.created_at }}
              </td>
              <td class="text-right" v-if="$store.user.type == 'admin'">
                <b-icon class="text-danger ml-2" icon="trash" @click.stop="deleteOrder(order.id)"/>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <b-pagination v-if="orders && orders.last_page > 1"
        :total-rows="orders.total"
        :per-page="orders.per_page"
        first-text="<<"
        prev-text="<"
        next-text=">"
        last-text=">>"
        v-model="page"
        />
    </div>

    <b-modal :visible="!!form" @hidden="form = null" hide-footer hide-header size="lg">
      <order-form v-if="form" :form="form" @saved="refreshOrders()" @close="form=null"/>
    </b-modal>

<!-- ................................................................................ -->




    <div class="" v-if="$store.user.type != 'admin'" >
      <div class="intestazione-vendite">
        Le tue vendite
      </div>
      <div>
        <div class="table table-hover table-responsive">
          <table class="order-table table-striped w-100" style="width:100%;">
            <thead>
              <tr>
                <th>ID</th>
                <!-- <th>Richiedente</th> -->
                <th>Stato Vendita</th>
                <th>Quantità</th>
                <th>Pallet</th>
                <th v-if="$store.user.type == 'admin'">Partner</th>
                <th class="text-right w-0"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!orders_partner">
                <td colspan="100%">
                  Caricamento...
                </td>
              </tr>
              <tr v-else-if="!orders_partner.total">
                <td colspan="100%">
                  Nessun ordine
                </td>
              </tr>
              <tr v-for="order in (orders_partner || {}).data" :key="order.id" class="pointer" @click="form_partner = _.cloneDeep(order)">

                <td>
                  #{{ order.proto }}
                </td>
                <!-- <td>
                  {{ order.user.company }} ({{ order.user.name }} {{order.user.surname}})
                </td> -->
                <!-- {{ order.user.full_name }} -->
                <td>
                  {{ $t('order_status.'+order.status) }}
                </td>
                <td>
                  {{ order.quantity }}
                </td>
                <td v-if="!order.product.is_varie">
                  {{ order.product.product_type.code }} / {{ order.product.name }}
                </td>
                <td v-else>
                  Varie / {{ order.product.name }}
                </td>
                <td v-if="$store.user.type == 'admin'">
                  <!-- {{ order.product.user.full_name }} -->
                  {{ order.product.user.company }} ({{ order.product.user.name }} {{order.product.user.surname}})
                </td>
                <td class="text-right" v-if="$store.user.type == 'admin'">
                  <b-icon class="text-danger ml-2" icon="trash" @click.stop="deleteOrder(order.id)"/>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <b-pagination v-if="orders_partner && orders_partner.last_page > 1"
          :total-rows="orders_partner.total"
          :per-page="orders_partner.per_page"
          first-text="<<"
          prev-text="<"
          next-text=">"
          last-text=">>"
          v-model="page_partner"
          />
      </div>

      <b-modal :visible="!!form_partner" @hidden="form_partner = null" hide-footer hide-header size="lg">
        <order-form v-if="form_partner" :form="form_partner" @saved="refreshOrders_Partner()" @close="form_partner=null"/>
      </b-modal>
    </div>



    <!-- {{orders_partner}} -->
  </b-container>
</template>

<script>
import OrderForm from '@/components/order-form'

export default {
  components: {
    OrderForm,
  },

  data() {
    return {
      orders: null,
      page: 1,
      form: null,
      show: true,

      orders_partner: null,
      page_partner: 1,
      form_partner: null,
      show_partner: true,
    }
  },
  computed: {
    get_order_filter(){
      if(this.$store.user.type == "admin"){
        return null;
      } else if(this.$store.user.type == "partner"){
        return "made"
      } else return null
    }
  },

  created() {
    this.refreshOrders()
    this.refreshOrders_Partner()
  },
  methods: {
    refreshOrders() {
      let params = {
        page: this.page,
        filter: this.get_order_filter
        // filter: this.$store.user.type
      }
      this.$http.get('orders', {
        params
      }).then(res => {
        this.orders = res.data
      })
    },
    refreshOrders_Partner() {
      let params = {
        page: this.page_partner,
        filter: "received"

        // filter: this.$store.user.type
      }
      this.$http.get('orders', {
        params
      }).then(res => {
        let dati_filtrati = res.data.data.filter(x => x.status != 'created' && x.status != 'assigned' && x.status != 'pending')
        this.orders_partner = res.data
        this.orders_partner.data = dati_filtrati
        // this.orders_partner.data = this.order_partner.data.filter(x => x.status != 'created' && x.status != 'assigned' && x.status != 'pending')
        // console.log(this.orders_partner)
        // this.order_partner = this.order_partner.filter(x => x.status != 'Creato' && x.status != 'In carico' && x.status != 'Offerta inviata')
      })
    },

    deleteOrder(id) {
      if (!confirm('Sicuro?')) return null
      this.$http.delete('orders/' + id).then(() => {
        this.refreshOrders()
        this.refreshOrders_Partner()
      })
    }
  },
  watch: {
    page() {
      this.refreshOrders()
      this.refreshOrders_Partner()
    }
  }


}
</script>

<style lang="scss">
  .intestazione-vendite{
    padding-top: 20px;
    padding-bottom: 20px;
    width: 100%;
    text-align: left;
    font-size: 28px;
    color: #81bb5d;
  }
  .orders-page{
    padding-left:0px;
    padding-right:0px;
  }
</style>
